// removed by extract-text-webpack-plugin
module.exports = {"commercials":"_25JmjQs-gj9oxgjVf6Sdns_0","lede":"_1apMvPggQK-HwsOy1oE65N_0","logos":"_1yxHGE0XZXMepXFw0V24Rz_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-rewriter.js?id=data-v-7a840429!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Commercials.vue
// module id = 61
// module chunks = 2